<template>
  <div class="pt-4 sm:pt-0 pl-2 sm:pl-0 pr-4 sm:pr-1 sm:pb-1 w-full h-full">
    <component :is="ComponentTool"></component>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ToolMain from './ToolMain.vue'
import ToolCaptureShoot from './ToolCaptureShoot.vue'
import ToolCaptureSave from './ToolCaptureSave.vue'
import ToolReports from './ToolReports.vue'
import ToolZoneShow from './ToolZoneShow.vue'
import ToolZones from './ToolZones.vue'
import ToolZoneNew from './ToolZoneNew.vue'

export default {
  name: 'MenuTools',
  computed: {
    ...mapGetters(['activeSubMenu']),
    ComponentTool: function () {
      if (this.activeSubMenu === 'Tool') return ToolMain
      if (this.activeSubMenu === 'ToolCaptureShoot') return ToolCaptureShoot
      if (this.activeSubMenu === 'ToolCaptureSave') return ToolCaptureSave
      if (this.activeSubMenu === 'ToolReports') return ToolReports
      if (this.activeSubMenu === 'ToolZoneShow') return ToolZoneShow
      if (this.activeSubMenu === 'ToolZones') return ToolZones
      if (this.activeSubMenu === 'ToolZoneNew') return ToolZoneNew

      return ToolMain
    }
  }
}
</script>
